var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"tooltipContainer":"_3ceBM"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3ceBM{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;margin:10px 10px 6px}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

runtime.addInitialStyle(module.exports);